import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import HeroSection from "../../components/heroSection/hero";
import BgImage from "../../images/background.png";
import Profile from "../../components/userProfile/profile";
import { getUserProfile } from "../../services/profile";
import { useCookies } from "react-cookie";
import LoginDialog from "../../components/dialog/loginDialog";
import { verifyToken } from "../../services/auth";

function ProfilePage() {
  const [cookies] = useCookies();
  const [profileData, setProfileData] = useState({});
  const [isData, setIsData] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    verifySession();
  }, []);

  async function getUserData() {
    await getUserProfile(cookies)
      .then((response) => {
        // console.log(response);
        if (response.data !== null) {
          setProfileData(response.data);
          setIsData(true);
        }
      })
      .catch((error) => console.log(error));
  }

  return (
    <Box>
      <LoginDialog open={open} />
      <HeroSection heroBgImage={BgImage} text={"Profile"} />
      <Profile
        isData={isData}
        profileData={profileData}
        setProfileData={setProfileData}
      />
    </Box>
  );

  async function verifySession() {
    await verifyToken(cookies)
      .then((response) => {
        // console.log(response.data)
        if (response.status === 400) setOpen(true);
        else getUserData();
      })
      .catch((error) => console.log(error));
  }
}

export default ProfilePage;
